var _path, _path2, _path3, _path4, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _rect15, _path15, _rect16, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _path24, _path25, _path26, _path27, _path28, _path29, _rect42, _path30, _rect43, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _rect67, _path49, _rect68, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _rect83, _rect84, _rect85, _rect86, _rect87, _rect88, _rect89, _rect90, _rect91, _rect92, _rect93, _rect94, _rect95, _rect96, _circle, _rect97, _rect98, _ellipse, _ellipse2, _circle2, _circle3, _path58, _ellipse3, _ellipse4, _path59, _ellipse5, _circle4, _rect99, _rect100, _ellipse6, _ellipse7, _circle5, _circle6, _path60, _circle7, _rect101, _rect102, _ellipse8, _ellipse9, _circle8, _circle9, _path61, _ellipse10, _path62, _circle10, _circle11, _circle12, _rect103, _ellipse11, _ellipse12, _circle13, _rect104, _ellipse13, _circle14, _circle15, _path63, _path64, _ellipse14, _circle16, _path65, _rect105;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDonutsLove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 891.38051,
    height: 573.8863,
    viewBox: "0 0 891.38051 573.8863",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "donut_love") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M222.56875,620.33642l-6.29347-24.82268a322.32428,322.32428,0,0,0-34.197-12.26884l-.79466,11.5361-3.22221-12.70926c-14.41146-4.11523-24.21557-5.92792-24.21557-5.92792s13.24309,50.35943,41.01953,88.85984l32.36563,5.68523-25.144,3.62529a130.406,130.406,0,0,0,11.24726,11.9192c40.40686,37.50621,85.41249,54.71427,100.52292,38.43523s-5.3964-59.88058-45.80326-97.38679c-12.52653-11.62729-28.2625-20.9581-44.01412-28.30163Z",
    transform: "translate(-153.84583 -158.53689)",
    fill: "#e6e6e6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M282.42465,593.37955l7.44338-24.50243a322.32527,322.32527,0,0,0-22.9324-28.17916l-6.64329,9.46467,3.81107-12.54527c-10.20968-10.97213-17.66546-17.59163-17.66546-17.59163S231.74378,569.981,235.62074,617.2968l24.76773,21.59665-23.39828-9.89354a130.40607,130.40607,0,0,0,3.4671,16.0171c15.20308,52.99336,44.83506,90.9877,66.18493,84.86272s26.33278-54.04988,11.1297-107.04324c-4.7131-16.42847-13.36069-32.55-23.04891-46.97843Z",
    transform: "translate(-153.84583 -158.53689)",
    fill: "#e6e6e6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M975.58764,646.17549l14.10965-8.8692a209.7704,209.7704,0,0,0,.74688-23.6325l-7.30238,1.81875,7.22418-4.541c-.3386-9.748-1.18-16.18181-1.18-16.18181s-28.53,18.28772-46.80571,43.199l2.96287,21.17974-7.2814-14.84306a84.86687,84.86687,0,0,0-5.12747,9.35189c-15.13006,32.533-16.77024,63.84761-3.66341,69.94318s35.99733-15.3362,51.12739-47.86919c4.69047-10.08555,7.31605-21.69838,8.708-32.92284Z",
    transform: "translate(-153.84583 -158.53689)",
    fill: "#e6e6e6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1004.26922,677.83874l16.663-.29913a209.77,209.77,0,0,0,12.855-19.84442l-7.19128-2.21768,8.53148-.15312c4.74887-8.51971,7.35422-14.46232,7.35422-14.46232s-33.87593.9079-62.39744,12.78639l-8.41148,19.66232,1.43918-16.47009a84.86767,84.86767,0,0,0-9.22335,5.35524c-29.76836,20.029-47.359,45.98787-39.28977,57.98089s38.74264,5.47859,68.511-14.55036c9.22848-6.20918,17.47879-14.79312,24.47228-23.68227Z",
    transform: "translate(-153.84583 -158.53689)",
    fill: "#e6e6e6"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.02923,
    y: 571.27262,
    width: 888,
    height: 2.24072,
    fill: "#3f3d56"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 402.42071,
    y: 219.04904,
    width: 2.57298,
    height: 13.89411,
    transform: "translate(-9.62947 -315.57896) rotate(26.64397)",
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 394.1956,
    y: 531.15953,
    width: 0.767,
    height: 4.14182,
    transform: "translate(-212.92504 -109.27081) rotate(-6.64807)",
    fill: "#3f3d56"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 396.7989,
    y: 565.65324,
    width: 0.767,
    height: 4.14182,
    transform: "translate(657.09276 -146.57383) rotate(71.64397)",
    fill: "#fff"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 395.06337,
    y: 546.1285,
    width: 0.767,
    height: 4.14182,
    transform: "translate(-186.03424 -133.81517) rotate(-3.44079)",
    fill: "#fff"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 391.48383,
    y: 523.4581,
    width: 0.767,
    height: 4.14182,
    transform: "translate(-184.68008 -134.07087) rotate(-3.44079)",
    fill: "#fff"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 444.38878,
    y: 538.69769,
    width: 0.767,
    height: 4.14182,
    transform: "translate(625.74572 -232.70659) rotate(68.00391)",
    fill: "#ff6584"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 400.26996,
    y: 538.96943,
    width: 0.767,
    height: 4.14182,
    transform: "translate(-0.16235 -243.79813) rotate(15)",
    fill: "#ff6584"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 286.47886,
    y: 70.60759,
    width: 2.41807,
    height: 13.05757,
    fill: "#3f3d56"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 285.02802,
    y: 102.04247,
    width: 2.41807,
    height: 13.05757,
    fill: "#fff"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 437.46869,
    y: 532.65692,
    width: 0.72082,
    height: 3.89245,
    transform: "translate(352.41285 -311.54718) rotate(45)",
    fill: "#fff"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 444.70642,
    y: 574.35035,
    width: 0.72082,
    height: 3.89245,
    transform: "translate(384.01445 -304.4533) rotate(45)",
    fill: "#fff"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 439.71136,
    y: 557.73414,
    width: 0.72082,
    height: 3.89245,
    transform: "translate(6.00519 -253.3652) rotate(15)",
    fill: "#ff6584"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 440.73076,
    y: 542.85091,
    width: 0.72082,
    height: 3.89245,
    transform: "translate(360.57654 -310.86806) rotate(45)",
    fill: "#ff6584"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M431.65184,543.20708a3.30682,3.30682,0,0,0-4.67655-4.67655L321.45871,644.04711a3.30682,3.30682,0,1,0,4.67655,4.67655L430.97271,543.88621",
    transform: "translate(-153.84583 -158.53689)",
    fill: "#3f3d56"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M442.43705,529.88991a49.7108,49.7108,0,1,0,12.377,49.80895A49.73292,49.73292,0,0,0,442.43705,529.88991Zm-40.70237,54.09446a20.57506,20.57506,0,0,1-9.0502-5.28168c-.50746-.50747-.97736-1.04316-1.4285-1.58825a20.621,20.621,0,1,1,10.4787,6.86993Z",
    transform: "translate(-153.84583 -158.53689)",
    fill: "#6c63ff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M329.77182,253.48205a11.093,11.093,0,0,0-22.186,0V721.02078a11.093,11.093,0,1,0,22.186,0V256.70392",
    transform: "translate(-153.84583 -158.53689)",
    fill: "#3f3d56"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M471.27367,249.33779A166.88907,166.88907,0,1,0,490.624,327.38746,166.80507,166.80507,0,0,0,471.27367,249.33779Zm-113.508,138.29035a69.16662,69.16662,0,1,1,35.167-60.24068A68.82727,68.82727,0,0,1,357.76562,387.62814Z",
    transform: "translate(-153.84583 -158.53689)",
    fill: "#6c63ff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M323.2902,483.59079A166.84215,166.84215,0,0,1,156.53211,321.94837q-.08665,2.70721-.08861,5.43522a166.8467,166.8467,0,1,0,333.69339,0q0-2.73149-.08831-5.44172A166.8422,166.8422,0,0,1,323.2902,483.59079Z",
    transform: "translate(-153.84583 -158.53689)",
    opacity: 0.2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M323.77337,244.13136a83.25143,83.25143,0,1,0,83.25617,83.2561A83.34882,83.34882,0,0,0,323.77337,244.13136Zm33.99225,143.49678a69.16662,69.16662,0,1,1,35.167-60.24068A68.82727,68.82727,0,0,1,357.76562,387.62814Z",
    transform: "translate(-153.84583 -158.53689)",
    opacity: 0.2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M471.276,247.33318v27.75459a10.1485,10.1485,0,0,1-17.4778,7.02689v3.16285a12.05649,12.05649,0,1,1-24.113,0v-2.6357a10.14321,10.14321,0,0,1-16.92647-7.554l-.48362-29.50043v-6.80445a4.11072,4.11072,0,0,0-8.22143,0v6.80445l-.48361,24.66429a10.15589,10.15589,0,0,1-20.31178,0l-1.24289-24.66429V232.97953a6.73673,6.73673,0,0,0-13.47346,0v12.60781l-.75928,24.66429a10.14811,10.14811,0,0,1-18.13551,6.26762,10.12858,10.12858,0,0,1-13.8507,2.01185v6.74641a12.05648,12.05648,0,1,1-24.113,0V264.44827a10.15184,10.15184,0,0,1-19.41226,4.16391v16.66533a12.05649,12.05649,0,1,1-24.113,0V245.58734h-.06771v39.69017a12.05649,12.05649,0,1,1-24.113,0V268.75242a10.14974,10.14974,0,0,1-19.34454-4.30415V245.58734h-1.03494v33.88681a12.05648,12.05648,0,0,1-24.113,0V264.44827a10.15589,10.15589,0,1,1-20.31177,0V242.09079A166.905,166.905,0,0,1,471.276,247.33318Z",
    transform: "translate(-153.84583 -158.53689)",
    fill: "#e6e6e6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M256.034,291.53063a12.05551,12.05551,0,0,1-12.05646-12.05648v6.287a12.05649,12.05649,0,0,0,24.113,0v-6.287A12.05555,12.05555,0,0,1,256.034,291.53063Z",
    transform: "translate(-153.84583 -158.53689)",
    opacity: 0.2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M280.2147,291.53063a12.05551,12.05551,0,0,1-12.05646-12.05648v6.287a12.05649,12.05649,0,0,0,24.113,0v-6.287A12.05555,12.05555,0,0,1,280.2147,291.53063Z",
    transform: "translate(-153.84583 -158.53689)",
    opacity: 0.2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M243.97756,262.94905a10.14974,10.14974,0,0,1-19.34454-4.30414v6.287a10.14974,10.14974,0,0,0,19.34454,4.30414Z",
    transform: "translate(-153.84583 -158.53689)",
    opacity: 0.2
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 114.2447,
    y: 81.24709,
    width: 0.06771,
    height: 6.28698,
    opacity: 0.2
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M199.48511,258.64491a10.15589,10.15589,0,0,1-20.31177,0v6.287a10.15589,10.15589,0,0,0,20.31177,0Z",
    transform: "translate(-153.84583 -158.53689)",
    opacity: 0.2
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 69.75225,
    y: 81.24709,
    width: 1.03494,
    height: 6.28698,
    opacity: 0.2
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M211.54156,285.72727a12.0555,12.0555,0,0,1-12.05645-12.05648v6.287a12.05649,12.05649,0,1,0,24.113,0v-6.287A12.05556,12.05556,0,0,1,211.54156,285.72727Z",
    transform: "translate(-153.84583 -158.53689)",
    opacity: 0.2
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M323.73992,291.53063a12.0555,12.0555,0,0,1-12.05645-12.05648v6.287a12.05649,12.05649,0,0,0,24.113,0v-6.287A12.05556,12.05556,0,0,1,323.73992,291.53063Z",
    transform: "translate(-153.84583 -158.53689)",
    opacity: 0.2
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M412.2751,232.97953a4.11071,4.11071,0,1,0-8.22143,0v6.287a4.11072,4.11072,0,1,1,8.22143,0Z",
    transform: "translate(-153.84583 -158.53689)",
    opacity: 0.2
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M311.68347,258.64491a10.15184,10.15184,0,0,1-19.41226,4.1639v6.287a10.15184,10.15184,0,0,0,19.41226-4.1639Z",
    transform: "translate(-153.84583 -158.53689)",
    opacity: 0.2
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M393.41417,274.60416a10.15465,10.15465,0,0,1-10.15589-10.15589L382.01536,239.784v6.287l1.24292,24.6643a10.15589,10.15589,0,0,0,20.31178,0l.48361-24.6643v-6.287l-.48361,24.66429A10.15465,10.15465,0,0,1,393.41417,274.60416Z",
    transform: "translate(-153.84583 -158.53689)",
    opacity: 0.2
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M461.12008,279.44029a10.12264,10.12264,0,0,1-7.32192-3.129v3.16285a12.05648,12.05648,0,0,1-24.113,0v-2.6357a10.14322,10.14322,0,0,1-16.92647-7.554L412.2751,239.784v6.287l.48362,29.50043a10.14322,10.14322,0,0,0,16.92647,7.55405v2.6357a12.05649,12.05649,0,0,0,24.113,0v-3.16285a10.14851,10.14851,0,0,0,17.4778-7.0269v-6.287A10.15465,10.15465,0,0,1,461.12008,279.44029Z",
    transform: "translate(-153.84583 -158.53689)",
    opacity: 0.2
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M357.62676,274.60416a10.13111,10.13111,0,0,1-7.97962-3.88827,10.12856,10.12856,0,0,1-13.8507,2.01184v6.287a10.12858,10.12858,0,0,0,13.8507-2.01185,10.14811,10.14811,0,0,0,18.13551-6.26761l.75931-24.6643v-6.287l-.75931,24.66429A10.15465,10.15465,0,0,1,357.62676,274.60416Z",
    transform: "translate(-153.84583 -158.53689)",
    opacity: 0.2
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M382.01536,227.17617a6.7367,6.7367,0,1,0-13.4734,0v6.287a6.7367,6.7367,0,1,1,13.4734,0Z",
    transform: "translate(-153.84583 -158.53689)",
    opacity: 0.2
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 113.10338,
    y: 69.88217,
    width: 2.41807,
    height: 13.05757,
    fill: "#3f3d56"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 158.80487,
    y: 62.86977,
    width: 2.41807,
    height: 13.05757,
    fill: "#3f3d56"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 100.77123,
    y: 114.13281,
    width: 2.41807,
    height: 13.05757,
    fill: "#3f3d56"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 349.88895,
    y: 248.00541,
    width: 2.41807,
    height: 13.05757,
    transform: "matrix(0.82235, 0.56898, -0.56898, 0.82235, 53.34956, -313.08642)",
    fill: "#3f3d56"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 230.91999,
    y: 227.69364,
    width: 2.41807,
    height: 13.05757,
    transform: "translate(-249.43113 112.39175) rotate(-51.64807)",
    fill: "#3f3d56"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 373.1024,
    y: 178.84866,
    width: 2.41807,
    height: 13.05757,
    transform: "translate(-157.16656 205.35607) rotate(-51.64807)",
    fill: "#3f3d56"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 204.32125,
    y: 241.23482,
    width: 2.41807,
    height: 13.05757,
    transform: "translate(-270.14481 96.67165) rotate(-51.64807)",
    fill: "#3f3d56"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 122.05023,
    y: 39.1727,
    width: 2.41807,
    height: 13.05757,
    fill: "#fff"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 55.79517,
    y: 106.395,
    width: 2.41807,
    height: 13.05757,
    fill: "#fff"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 168.96075,
    y: 20.31177,
    width: 2.41807,
    height: 13.05757,
    fill: "#fff"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 333.44608,
    y: 223.34111,
    width: 2.41807,
    height: 13.05757,
    transform: "translate(-15.2249 -284.20154) rotate(26.64397)",
    fill: "#fff"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 322.32297,
    y: 271.70248,
    width: 2.41807,
    height: 13.05757,
    transform: "translate(5.28136 -274.07796) rotate(26.64397)",
    fill: "#fff"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 297.17506,
    y: 245.10373,
    width: 2.41807,
    height: 13.05757,
    transform: "translate(-241.69706 149.43621) rotate(-48.44079)",
    fill: "#fff"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 249.29731,
    y: 188.52093,
    width: 2.41807,
    height: 13.05757,
    transform: "translate(-215.47377 94.56458) rotate(-48.44079)",
    fill: "#fff"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 408.40619,
    y: 210.28355,
    width: 2.41807,
    height: 13.05757,
    transform: "translate(-178.20105 220.9465) rotate(-48.44079)",
    fill: "#fff"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 349.88895,
    y: 167.72555,
    width: 2.41807,
    height: 13.05757,
    transform: "translate(-166.05342 162.83448) rotate(-48.44079)",
    fill: "#fff"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 140.42755,
    y: 62.86977,
    width: 2.41807,
    height: 13.05757,
    fill: "#ff6584"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 428.23435,
    y: 228.66086,
    width: 2.41807,
    height: 13.05757,
    transform: "translate(-27.78501 -307.65806) rotate(23.00391)",
    fill: "#ff6584"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 249.29731,
    y: 242.20205,
    width: 2.41807,
    height: 13.05757,
    transform: "translate(-244.64976 0.0399) rotate(-30)",
    fill: "#ff6584"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 387.61081,
    y: 233.01339,
    width: 2.41807,
    height: 13.05757,
    transform: "translate(-221.52493 67.9656) rotate(-30)",
    fill: "#ff6584"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 301.52758,
    y: 185.13564,
    width: 2.41807,
    height: 13.05757,
    transform: "matrix(0.86603, -0.5, 0.5, 0.86603, -209.11902, 18.50958)",
    fill: "#ff6584"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 404.05367,
    y: 182.71757,
    width: 2.41807,
    height: 13.05757,
    transform: "translate(-194.1741 69.44867) rotate(-30)",
    fill: "#ff6584"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 271.05993,
    y: 172.07807,
    width: 2.41807,
    height: 13.05757,
    transform: "translate(-206.67213 1.52637) rotate(-30)",
    fill: "#ff6584"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 200.87925,
    y: 36.75464,
    width: 2.41807,
    height: 13.05757,
    fill: "#ff6584"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 61.59853,
    y: 58.51725,
    width: 2.41807,
    height: 13.05757,
    fill: "#ff6584"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M374.238,597.88845a49.73552,49.73552,0,0,1-1.07833-69.22288q-.5889.55237-1.16435,1.127a49.73687,49.73687,0,1,0,70.33855,70.33855q.57578-.57576,1.12844-1.16566A49.73552,49.73552,0,0,1,374.238,597.88845Z",
    transform: "translate(-153.84583 -158.53689)",
    opacity: 0.2
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M426.82713,545.49989a27.67379,27.67379,0,1,0,0,39.12353A27.70849,27.70849,0,0,0,426.82713,545.49989Zm-4.98094,33.2028a20.62675,20.62675,0,0,1-29.16171,0c-.50746-.50747-.97736-1.04316-1.4285-1.58825a20.61619,20.61619,0,1,1,30.59021,1.58825Z",
    transform: "translate(-153.84583 -158.53689)",
    opacity: 0.2
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M455.81028,578.70338,449.96,584.55371a3.02525,3.02525,0,0,1-5.16529-2.20292l-.6667.66669a3.594,3.594,0,0,1-5.08272-5.08273l.55557-.55557a3.02369,3.02369,0,0,1-1.97559-5.1602l6.11639-6.32028,1.4343-1.43429a1.2254,1.2254,0,0,0-1.733-1.733l-1.43429,1.4343-5.30088,5.097a3.02746,3.02746,0,0,1-4.28148-4.28147l4.93695-5.46093,2.65758-2.65757a2.00822,2.00822,0,0,0-2.84-2.84005l-2.65757,2.65758-5.359,5.03889a34.69534,34.69534,0,0,0-7.64549-3.364,3.01679,3.01679,0,0,1-.842-1.63308l-1.42206,1.42206a3.594,3.594,0,0,1-5.08272-5.08272l4.39055-4.39055a3.02625,3.02625,0,0,1-4.96957-3.21417L410.08,548.96954a3.594,3.594,0,0,1-5.08272-5.08273l8.36621-8.36621-.01427-.01427-8.36621,8.36621a3.594,3.594,0,0,1-5.08273-5.08272l3.4833-3.48329a3.02563,3.02563,0,0,1-3.17034-4.98486l3.97566-3.97566-.21815-.21815-7.14294,7.14293a3.594,3.594,0,0,1-5.08272-5.08273l3.16727-3.16727a3.02746,3.02746,0,0,1-4.28147-4.28148l4.71268-4.71269a49.75425,49.75425,0,0,1,60.46669,62.67676Z",
    transform: "translate(-153.84583 -158.53689)",
    fill: "#e6e6e6"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M401.12358,542.64926a3.59373,3.59373,0,0,1,0-5.08272l-1.32522,1.32522a3.594,3.594,0,0,0,5.08273,5.08272l1.32522-1.32522A3.59376,3.59376,0,0,1,401.12358,542.64926Z",
    transform: "translate(-153.84583 -158.53689)",
    opacity: 0.2
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M406.22057,547.74625a3.59373,3.59373,0,0,1,0-5.08271l-1.32522,1.32521a3.594,3.594,0,1,0,5.08273,5.08273l1.32521-1.32522A3.59375,3.59375,0,0,1,406.22057,547.74625Z",
    transform: "translate(-153.84583 -158.53689)",
    opacity: 0.2
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M404.60688,534.08325a3.02563,3.02563,0,0,1-3.17034-4.98486l-1.32522,1.32522a3.02563,3.02563,0,0,0,3.17034,4.98486Z",
    transform: "translate(-153.84583 -158.53689)",
    opacity: 0.2
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 412.97997,
    y: 534.9427,
    width: 1.87414,
    height: 0.02019,
    transform: "translate(-410.88108 290.83071) rotate(-45)",
    opacity: 0.2
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M396.13566,523.79751a3.02746,3.02746,0,1,1-4.28147-4.28148l-1.32522,1.32522a3.02746,3.02746,0,0,0,4.28147,4.28148Z",
    transform: "translate(-153.84583 -158.53689)",
    opacity: 0.2
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 403.70344,
    y: 525.52201,
    width: 1.87414,
    height: 0.30851,
    transform: "translate(-407.03862 281.55417) rotate(-45)",
    opacity: 0.2
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M392.96838,532.0475a3.59373,3.59373,0,0,1,0-5.08271L391.64317,528.29a3.594,3.594,0,1,0,5.08272,5.08273l1.32522-1.32522A3.59375,3.59375,0,0,1,392.96838,532.0475Z",
    transform: "translate(-153.84583 -158.53689)",
    opacity: 0.2
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M415.39517,556.92085a3.59374,3.59374,0,0,1,0-5.08272L414.07,553.16335a3.594,3.594,0,1,0,5.08272,5.08272l1.32522-1.32522A3.59376,3.59376,0,0,1,415.39517,556.92085Z",
    transform: "translate(-153.84583 -158.53689)",
    opacity: 0.2
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M446.39919,563.24113a1.2254,1.2254,0,0,0-1.733-1.733l-1.32522,1.32522a1.2254,1.2254,0,1,1,1.733,1.733Z",
    transform: "translate(-153.84583 -158.53689)",
    opacity: 0.2
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M419.78573,547.44758a3.02625,3.02625,0,0,1-4.96957-3.21417l-1.32522,1.32522a3.02625,3.02625,0,0,0,4.96957,3.21417Z",
    transform: "translate(-153.84583 -158.53689)",
    opacity: 0.2
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M433.64956,568.03944a3.02709,3.02709,0,0,1,0-4.28147l4.93694-5.46093-1.32521,1.32522-4.93695,5.46093a3.02746,3.02746,0,1,0,4.28148,4.28147l5.30088-5.097,1.32521-1.32522-5.30087,5.097A3.0271,3.0271,0,0,1,433.64956,568.03944Z",
    transform: "translate(-153.84583 -158.53689)",
    opacity: 0.2
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M446.90175,583.33043a3.01751,3.01751,0,0,1-.88382-2.20292l-.66669.66669a3.594,3.594,0,1,1-5.08272-5.08273l.55557-.55557a3.02369,3.02369,0,0,1-1.97559-5.1602l6.11639-6.32027-1.32522,1.32521-6.11639,6.32028a3.02369,3.02369,0,0,0,1.97559,5.1602l-.55557.55557a3.594,3.594,0,1,0,5.08272,5.08273l.6667-.66669a3.02525,3.02525,0,0,0,5.16529,2.20292l1.32522-1.32522A3.02708,3.02708,0,0,1,446.90175,583.33043Z",
    transform: "translate(-153.84583 -158.53689)",
    opacity: 0.2
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M426.106,560.49589a3.02038,3.02038,0,0,0-3.364-3.364,3.01685,3.01685,0,0,1-.842-1.63308l-1.32522,1.32522a5.80371,5.80371,0,0,1,4.20605,4.9971,3.02709,3.02709,0,0,0,4.28147,0l5.359-5.03889,1.32522-1.32522-5.359,5.03889A3.0271,3.0271,0,0,1,426.106,560.49589Z",
    transform: "translate(-153.84583 -158.53689)",
    opacity: 0.2
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M441.24408,555.63946a2.0082,2.0082,0,1,0-2.84-2.84l-1.32522,1.32522a2.0082,2.0082,0,1,1,2.84,2.84Z",
    transform: "translate(-153.84583 -158.53689)",
    opacity: 0.2
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 415.24578,
    y: 531.3317,
    width: 0.72082,
    height: 3.89245,
    transform: "translate(344.96684 -296.22136) rotate(45)",
    fill: "#3f3d56"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 426.35723,
    y: 539.48689,
    width: 0.72082,
    height: 3.89245,
    transform: "translate(353.98791 -301.68974) rotate(45)",
    fill: "#3f3d56"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 437.35723,
    y: 533.48689,
    width: 0.72082,
    height: 3.89245,
    transform: "translate(352.96709 -311.22527) rotate(45)",
    fill: "#3f3d56"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 403.31881,
    y: 538.05974,
    width: 0.72082,
    height: 3.89245,
    transform: "translate(346.23095 -285.81712) rotate(45)",
    fill: "#3f3d56"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 428.59991,
    y: 552.94297,
    width: 0.72082,
    height: 3.89245,
    transform: "translate(744.17072 -125.08344) rotate(79.67891)",
    fill: "#3f3d56"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 444.59991,
    y: 545.94297,
    width: 0.72082,
    height: 3.89245,
    transform: "translate(750.41735 -146.5704) rotate(79.67891)",
    fill: "#3f3d56"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 407.80416,
    y: 523.58426,
    width: 0.72082,
    height: 3.89245,
    transform: "translate(-211.94226 -107.74979) rotate(-6.64807)",
    fill: "#3f3d56"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 399.34315,
    y: 520.83189,
    width: 0.72082,
    height: 3.89245,
    transform: "translate(-211.68051 -108.74783) rotate(-6.64807)",
    fill: "#3f3d56"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 423.60485,
    y: 526.7444,
    width: 0.72082,
    height: 3.89245,
    transform: "translate(344.17145 -303.4757) rotate(45)",
    fill: "#fff"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 444.60485,
    y: 540.7444,
    width: 0.72082,
    height: 3.89245,
    transform: "translate(360.2217 -314.22444) rotate(45)",
    fill: "#fff"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 452.60485,
    y: 560.7444,
    width: 0.72082,
    height: 3.89245,
    transform: "translate(376.70699 -314.02343) rotate(45)",
    fill: "#fff"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 395.46943,
    y: 526.94828,
    width: 0.72082,
    height: 3.89245,
    transform: "translate(336.07494 -283.52124) rotate(45)",
    fill: "#fff"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 430.33289,
    y: 544.27807,
    width: 0.72082,
    height: 3.89245,
    transform: "translate(659.64447 -193.10873) rotate(71.64397)",
    fill: "#fff"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 417.79428,
    y: 552.12745,
    width: 0.72082,
    height: 3.89245,
    transform: "translate(658.50452 -175.83067) rotate(71.64397)",
    fill: "#fff"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 418.1001,
    y: 541.21987,
    width: 0.72082,
    height: 3.89245,
    transform: "translate(-185.69067 -132.44303) rotate(-3.44079)",
    fill: "#fff"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 419.93502,
    y: 519.20085,
    width: 0.72082,
    height: 3.89245,
    transform: "translate(-184.36584 -132.3726) rotate(-3.44079)",
    fill: "#fff"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 422.48351,
    y: 535.61318,
    width: 0.72082,
    height: 3.89245,
    transform: "translate(350.11419 -300.08519) rotate(45)",
    fill: "#ff6584"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 446.48351,
    y: 569.61318,
    width: 0.72082,
    height: 3.89245,
    transform: "translate(381.18526 -307.09739) rotate(45)",
    fill: "#ff6584"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 450.48351,
    y: 552.61318,
    width: 0.72082,
    height: 3.89245,
    transform: "translate(370.33602 -314.905) rotate(45)",
    fill: "#ff6584"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 408.61968,
    y: 530.51618,
    width: 0.72082,
    height: 3.89245,
    transform: "translate(-2.09876 -246.24551) rotate(15)",
    fill: "#ff6584"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 431.65811,
    y: 529.49678,
    width: 0.72082,
    height: 3.89245,
    transform: "translate(-1.57758 -252.24303) rotate(15)",
    fill: "#ff6584"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 427.98827,
    y: 520.32219,
    width: 0.72082,
    height: 3.89245,
    transform: "translate(-4.07719 -251.60582) rotate(15)",
    fill: "#ff6584"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 406.78476,
    y: 518.07951,
    width: 0.72082,
    height: 3.89245,
    transform: "translate(333.11796 -294.11999) rotate(45)",
    fill: "#ff6584"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M929.22634,365.46674a8,8,0,1,0-16,0V724.1138a8,8,0,0,0,16,0V367.79027",
    transform: "translate(-153.84583 -158.53689)",
    fill: "#3f3d56"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M1031.27639,384.50023a120.36217,120.36217,0,0,0-221.22,92.29h14.93c3,0,5.46,3.34,5.46,7.43h2.74c3.01,0,5.47,3.34,5.47,7.43,0,4.08-2.46,7.43-5.47,7.43h-2.74a10.08719,10.08719,0,0,1-.18994,1.85h12.5c3.01,0,5.47,3.35,5.47,7.43,0,4.09-2.46,7.43-5.47,7.43h-11.94a120.34008,120.34008,0,0,0,200.46-131.29Zm-81.86,99.74005a49.676,49.676,0,0,1-24.52,6.42,51.4728,51.4728,0,0,1-5.15-.26,49.849,49.849,0,1,1,29.67-6.16Z",
    transform: "translate(-153.84583 -158.53689)",
    fill: "#6c63ff"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M847.89894,505.86168a9.73571,9.73571,0,0,0,.3274-2.5c0-4.08576-2.46118-7.42859-5.46936-7.42859H837.6404a5.2394,5.2394,0,0,1-4.45483,3.14288h-2.73475a9.75369,9.75369,0,0,1-.19555,1.85712H842.757C845.11916,500.93309,847.1382,502.998,847.89894,505.86168Z",
    transform: "translate(-153.84583 -158.53689)",
    opacity: 0.2
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M833.18557,484.21879c2.36206,0,4.3811,2.065,5.14184,4.92859a9.73038,9.73038,0,0,0,.32752-2.5c0-4.08575-2.46131-7.42859-5.46936-7.42859h-2.73475c0-4.08569-2.46118-7.42852-5.46936-7.42852H810.05568a120.18149,120.18149,0,0,1-5.436-33.67182c-.01953.88953-.04456,1.77765-.04456,2.67182a120.27579,120.27579,0,0,0,5.48059,36h14.92578c3.00818,0,5.46936,3.34283,5.46936,7.42852Z",
    transform: "translate(-153.84583 -158.53689)",
    opacity: 0.2
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M924.90065,556.11589a120.01732,120.01732,0,0,1-89.86987-40.32562h-4.2185a120.3234,120.3234,0,0,0,214.41406-75c0-.75226-.02112-1.49951-.03491-2.24848A120.32312,120.32312,0,0,1,924.90065,556.11589Z",
    transform: "translate(-153.84583 -158.53689)",
    opacity: 0.2
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M924.89632,380.92027a59.87,59.87,0,1,0,59.88007,59.87A59.94091,59.94091,0,0,0,924.89632,380.92027Zm24.52,103.32a49.676,49.676,0,0,1-24.52,6.42,51.4728,51.4728,0,0,1-5.15-.26,49.849,49.849,0,1,1,29.67-6.16Z",
    transform: "translate(-153.84583 -158.53689)",
    opacity: 0.2
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M1031.27554,382.50229V402.5182a7.31884,7.31884,0,0,1-12.60455,5.06761v2.281a8.69483,8.69483,0,1,1-17.38966,0V407.966a7.315,7.315,0,0,1-12.207-5.44778l-.34877-21.275V376.336a2.96454,2.96454,0,1,0-5.92908,0v4.90719l-.34877,17.78727a7.32417,7.32417,0,0,1-14.64834,0l-.89634-17.78727V372.1508a4.85836,4.85836,0,0,0-9.71673,0v9.09243l-.54757,17.78727a7.31856,7.31856,0,0,1-13.07887,4.52,7.30445,7.30445,0,0,1-9.98877,1.4509v4.86534a8.69483,8.69483,0,0,1-17.38966,0V394.84526a7.32125,7.32125,0,0,1-13.99963,3.0029v12.01862a8.69484,8.69484,0,0,1-17.38967,0V381.24323h-.04883v28.62355a8.69483,8.69483,0,1,1-17.38966,0V397.9493a7.31974,7.31974,0,0,1-13.9508-3.104v-13.602h-.74637v24.43831a8.69483,8.69483,0,0,1-17.38966,0V394.84526a7.32417,7.32417,0,0,1-14.64834,0V378.72161a120.36764,120.36764,0,0,1,210.657,3.78068Z",
    transform: "translate(-153.84583 -158.53689)",
    fill: "#e6e6e6"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M876.0485,414.37637a8.69412,8.69412,0,0,1-8.69481-8.69483v4.534a8.69483,8.69483,0,0,0,17.38966,0v-4.534A8.69416,8.69416,0,0,1,876.0485,414.37637Z",
    transform: "translate(-153.84583 -158.53689)",
    opacity: 0.2
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M893.487,414.37637a8.69413,8.69413,0,0,1-8.69481-8.69483v4.534a8.69483,8.69483,0,0,0,17.38967,0v-4.534A8.69417,8.69417,0,0,1,893.487,414.37637Z",
    transform: "translate(-153.84583 -158.53689)",
    opacity: 0.2
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M867.35369,393.76406a7.31974,7.31974,0,0,1-13.9508-3.104v4.534a7.31974,7.31974,0,0,0,13.9508,3.104Z",
    transform: "translate(-153.84583 -158.53689)",
    opacity: 0.2
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 730.89752,
    y: 218.52111,
    width: 0.04883,
    height: 4.53401,
    opacity: 0.2
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M835.26686,390.66a7.32417,7.32417,0,0,1-14.64834,0v4.534a7.32417,7.32417,0,0,0,14.64834,0Z",
    transform: "translate(-153.84583 -158.53689)",
    opacity: 0.2
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 698.81069,
    y: 218.52111,
    width: 0.74637,
    height: 4.53401,
    opacity: 0.2
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M843.96167,410.19114a8.69413,8.69413,0,0,1-8.69481-8.69484v4.534a8.69483,8.69483,0,0,0,17.38966,0v-4.534A8.69417,8.69417,0,0,1,843.96167,410.19114Z",
    transform: "translate(-153.84583 -158.53689)",
    opacity: 0.2
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M924.87628,414.37637a8.69412,8.69412,0,0,1-8.6948-8.69483v4.534a8.69483,8.69483,0,1,0,17.38966,0v-4.534A8.69417,8.69417,0,0,1,924.87628,414.37637Z",
    transform: "translate(-153.84583 -158.53689)",
    opacity: 0.2
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M988.72561,372.1508a2.96454,2.96454,0,1,0-5.92908,0v4.534a2.96454,2.96454,0,1,1,5.92908,0Z",
    transform: "translate(-153.84583 -158.53689)",
    opacity: 0.2
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M916.18148,390.66a7.32125,7.32125,0,0,1-13.99963,3.0029v4.534a7.32125,7.32125,0,0,0,13.99963-3.0029Z",
    transform: "translate(-153.84583 -158.53689)",
    opacity: 0.2
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M975.12359,402.16943a7.32328,7.32328,0,0,1-7.32417-7.32417l-.89636-17.78727v4.534l.89636,17.78727a7.32417,7.32417,0,0,0,14.64834,0l.34877-17.78727v-4.534l-.34877,17.78727A7.32328,7.32328,0,0,1,975.12359,402.16943Z",
    transform: "translate(-153.84583 -158.53689)",
    opacity: 0.2
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M1023.95137,405.65713a7.30018,7.30018,0,0,1-5.28038-2.25656v2.281a8.69483,8.69483,0,1,1-17.38966,0v-1.9008a7.315,7.315,0,0,1-12.207-5.44778l-.34877-21.275v4.534l.34877,21.275a7.315,7.315,0,0,0,12.207,5.44778v1.9008a8.69483,8.69483,0,0,0,17.38966,0v-2.281a7.31884,7.31884,0,0,0,12.60455-5.06761v-4.534A7.32328,7.32328,0,0,1,1023.95137,405.65713Z",
    transform: "translate(-153.84583 -158.53689)",
    opacity: 0.2
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M949.31462,402.16943a7.3063,7.3063,0,0,1-5.75471-2.80413,7.30445,7.30445,0,0,1-9.98877,1.4509v4.534a7.30445,7.30445,0,0,0,9.98877-1.4509,7.31856,7.31856,0,0,0,13.07887-4.52l.5476-17.78727v-4.534l-.5476,17.78727A7.32327,7.32327,0,0,1,949.31462,402.16943Z",
    transform: "translate(-153.84583 -158.53689)",
    opacity: 0.2
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M966.90306,367.96556a4.85834,4.85834,0,1,0-9.71668,0v4.534a4.85834,4.85834,0,1,1,9.71668,0Z",
    transform: "translate(-153.84583 -158.53689)",
    opacity: 0.2
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 730.07443,
    y: 210.32501,
    width: 1.74385,
    height: 9.41679,
    fill: "#3f3d56"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 763.03319,
    y: 205.26785,
    width: 1.74385,
    height: 9.41679,
    fill: "#3f3d56"
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 855.10844,
    y: 210.84817,
    width: 1.74385,
    height: 9.41679,
    fill: "#3f3d56"
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 721.1808,
    y: 242.23746,
    width: 1.74385,
    height: 9.41679,
    fill: "#3f3d56"
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 943.7343,
    y: 382.98708,
    width: 1.74385,
    height: 9.41679,
    transform: "translate(234.5499 -627.12325) rotate(34.67891)",
    fill: "#3f3d56"
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    x: 857.9369,
    y: 368.33875,
    width: 1.74385,
    height: 9.41679,
    transform: "translate(-120.46825 656.52838) rotate(-51.64807)",
    fill: "#3f3d56"
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    x: 960.47525,
    y: 333.11299,
    width: 1.74385,
    height: 9.41679,
    transform: "translate(-53.92938 723.57189) rotate(-51.64807)",
    fill: "#3f3d56"
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    x: 838.75456,
    y: 378.1043,
    width: 1.74385,
    height: 9.41679,
    transform: "matrix(0.62049, -0.78421, 0.78421, 0.62049, -135.40643, 645.19143)",
    fill: "#3f3d56"
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    x: 736.52668,
    y: 188.17812,
    width: 1.74385,
    height: 9.41679,
    fill: "#fff"
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    x: 688.7452,
    y: 236.65714,
    width: 1.74385,
    height: 9.41679,
    fill: "#fff"
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    x: 770.35736,
    y: 174.5761,
    width: 1.74385,
    height: 9.41679,
    fill: "#fff"
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    x: 854.06213,
    y: 233.51821,
    width: 1.74385,
    height: 9.41679,
    fill: "#fff"
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    x: 931.87612,
    y: 365.19982,
    width: 1.74385,
    height: 9.41679,
    transform: "translate(111.08586 -537.54276) rotate(26.64397)",
    fill: "#fff"
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    x: 923.85441,
    y: 400.07681,
    width: 1.74385,
    height: 9.41679,
    transform: "translate(125.87445 -530.24189) rotate(26.64397)",
    fill: "#fff"
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    x: 1020.1149,
    y: 384.38216,
    width: 1.74385,
    height: 9.41679,
    transform: "translate(129.05813 -575.07605) rotate(26.64397)",
    fill: "#fff"
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    x: 905.71838,
    y: 380.89446,
    width: 1.74385,
    height: 9.41679,
    transform: "translate(-137.21709 649.63424) rotate(-48.44079)",
    fill: "#fff"
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    x: 871.19016,
    y: 340.08839,
    width: 1.74385,
    height: 9.41679,
    transform: "translate(-118.30552 610.06221) rotate(-48.44079)",
    fill: "#fff"
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    x: 985.93545,
    y: 355.78303,
    width: 1.74385,
    height: 9.41679,
    transform: "translate(-91.42538 701.20565) rotate(-48.44079)",
    fill: "#fff"
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    x: 943.7343,
    y: 325.09128,
    width: 1.74385,
    height: 9.41679,
    transform: "translate(-82.66482 659.29673) rotate(-48.44079)",
    fill: "#fff"
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    x: 749.77993,
    y: 205.26785,
    width: 1.74385,
    height: 9.41679,
    fill: "#ff6584"
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    x: 1000.23502,
    y: 369.03629,
    width: 1.74385,
    height: 9.41679,
    transform: "translate(71.82119 -520.04258) rotate(23.00391)",
    fill: "#ff6584"
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    x: 871.19016,
    y: 378.80184,
    width: 1.74385,
    height: 9.41679,
    transform: "translate(-228.76678 328.87478) rotate(-30)",
    fill: "#ff6584"
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    x: 970.93835,
    y: 372.17522,
    width: 1.74385,
    height: 9.41679,
    transform: "translate(-212.08974 377.86108) rotate(-30)",
    fill: "#ff6584"
  })), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    x: 908.85731,
    y: 337.647,
    width: 1.74385,
    height: 9.41679,
    transform: "translate(-203.14292 342.19465) rotate(-30)",
    fill: "#ff6584"
  })), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    x: 982.79653,
    y: 335.90315,
    width: 1.74385,
    height: 9.41679,
    transform: "translate(-192.36501 378.93063) rotate(-30)",
    fill: "#ff6584"
  })), _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    x: 886.8848,
    y: 328.23021,
    width: 1.74385,
    height: 9.41679,
    transform: "translate(-201.37828 329.94679) rotate(-30)",
    fill: "#ff6584"
  })), _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    x: 793.37617,
    y: 186.43428,
    width: 1.74385,
    height: 9.41679,
    fill: "#ff6584"
  })), _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    x: 692.93044,
    y: 202.12892,
    width: 1.74385,
    height: 9.41679,
    fill: "#ff6584"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 354.2577,
    cy: 504.17744,
    r: 42.01233,
    fill: "#2f2e41"
  })), _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    x: 522.19111,
    y: 692.70227,
    width: 12.76324,
    height: 22.86747,
    transform: "translate(1020.27603 1144.31688) rotate(169.73894)",
    fill: "#2f2e41"
  })), _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
    x: 497.07289,
    y: 697.24939,
    width: 12.76324,
    height: 22.86747,
    transform: "translate(971.25133 1157.81279) rotate(169.73894)",
    fill: "#2f2e41"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 503.30105,
    cy: 722.76249,
    rx: 10.63603,
    ry: 3.98851,
    transform: "translate(-501.71835 337.949) rotate(-40.26106)",
    fill: "#2f2e41"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 527.89598,
    cy: 718.3101,
    rx: 10.63603,
    ry: 3.98851,
    transform: "translate(-493.01455 352.78925) rotate(-40.26106)",
    fill: "#2f2e41"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 351.31647,
    cy: 493.90098,
    r: 14.35865,
    fill: "#fff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 345.41511,
    cy: 488.75418,
    r: 4.78622,
    fill: "#3f3d56"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M541.24539,617.00941c.63179-15.55359-12.77316-28.72759-29.94081-29.42494s-31.59693,11.346-32.22872,26.89959,11.3019,19.08749,28.46954,19.78485S540.61359,632.563,541.24539,617.00941Z",
    transform: "translate(-153.84583 -158.53689)",
    fill: "#cfcce0"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 469.31095,
    cy: 655.06038,
    rx: 6.59448,
    ry: 21.00617,
    transform: "translate(-427.8909 807.61624) rotate(-77.0899)",
    fill: "#2f2e41"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 551.77957,
    cy: 668.77479,
    rx: 6.59448,
    ry: 21.00617,
    transform: "translate(-377.21531 898.65051) rotate(-77.0899)",
    fill: "#2f2e41"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M519.64223,679.27086a9.57243,9.57243,0,1,1-18.83866,3.41034c-.94174-5.20215,3.08039-7.043,8.28255-7.98473S518.70049,674.0687,519.64223,679.27086Z",
    transform: "translate(-153.84583 -158.53689)",
    fill: "#fff"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 740.58277,
    cy: 514.54807,
    rx: 21.53367,
    ry: 6.76008,
    transform: "translate(-158.30834 864.07622) rotate(-69.08217)",
    fill: "#2f2e41"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 561.64904,
    cy: 512.28366,
    r: 43.06734,
    fill: "#2f2e41"
  })), _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
    x: 542.02342,
    y: 546.08334,
    width: 13.08375,
    height: 23.44171,
    fill: "#2f2e41"
  })), _rect100 || (_rect100 = /*#__PURE__*/React.createElement("rect", {
    x: 568.19092,
    y: 546.08334,
    width: 13.08375,
    height: 23.44171,
    fill: "#2f2e41"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 552.92654,
    cy: 569.79763,
    rx: 10.90312,
    ry: 4.08867,
    fill: "#2f2e41"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 579.09404,
    cy: 569.25247,
    rx: 10.90312,
    ry: 4.08867,
    fill: "#2f2e41"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 562.73936,
    cy: 501.38053,
    r: 14.71922,
    fill: "#fff"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 562.73936,
    cy: 501.38053,
    r: 4.90641,
    fill: "#3f3d56"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M673.7181,630.76916c-3.47749-15.57379,7.63865-31.31045,24.82859-35.14881s33.9442,5.67508,37.42169,21.24887-7.91491,21.31768-25.10485,25.156S677.19559,646.343,673.7181,630.76916Z",
    transform: "translate(-153.84583 -158.53689)",
    fill: "#cfcce0"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 546.92983,
    cy: 388.53321,
    r: 43.06734,
    fill: "#2f2e41"
  })), _rect101 || (_rect101 = /*#__PURE__*/React.createElement("rect", {
    x: 527.30421,
    y: 422.33289,
    width: 13.08375,
    height: 23.44171,
    fill: "#2f2e41"
  })), _rect102 || (_rect102 = /*#__PURE__*/React.createElement("rect", {
    x: 553.4717,
    y: 422.33289,
    width: 13.08375,
    height: 23.44171,
    fill: "#2f2e41"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 538.20733,
    cy: 446.04718,
    rx: 10.90312,
    ry: 4.08867,
    fill: "#2f2e41"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 564.37482,
    cy: 445.50203,
    rx: 10.90312,
    ry: 4.08867,
    fill: "#2f2e41"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 548.02014,
    cy: 377.63009,
    r: 14.71922,
    fill: "#fff"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 548.02014,
    cy: 377.63009,
    r: 4.90641,
    fill: "#3f3d56"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M658.99888,507.01872c-3.47749-15.57379,7.63865-31.31045,24.82859-35.14882s33.9442,5.67509,37.42169,21.24888-7.91491,21.31767-25.10485,25.156S662.47637,522.59251,658.99888,507.01872Z",
    transform: "translate(-153.84583 -158.53689)",
    fill: "#cfcce0"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 652.26748,
    cy: 527.08666,
    rx: 6.76008,
    ry: 21.53367,
    transform: "translate(-257.33156 732.01958) rotate(-64.62574)",
    fill: "#2f2e41"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M679.62111,562.60705c0,4.21514,10.8533,12.53859,22.89656,12.53859s23.33517-11.867,23.33517-16.08211-11.29191.81774-23.33517.81774S679.62111,558.39191,679.62111,562.60705Z",
    transform: "translate(-153.84583 -158.53689)",
    fill: "#fff"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 672.69741,
    cy: 441.68977,
    r: 6,
    fill: "#6c63ff"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 689.03954,
    cy: 393.25338,
    r: 6,
    fill: "#6c63ff"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 674.09686,
    cy: 368.49467,
    r: 6,
    fill: "#6c63ff"
  })), _rect103 || (_rect103 = /*#__PURE__*/React.createElement("rect", {
    x: 782.17044,
    y: 687.08917,
    width: 12.11266,
    height: 21.70185,
    transform: "matrix(-0.26644, -0.96385, 0.96385, -0.26644, 171.68106, 1485.09376)",
    fill: "#2f2e41"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 774.9067,
    cy: 699.00402,
    rx: 3.78521,
    ry: 10.09388,
    transform: "matrix(0.96385, -0.26644, 0.26644, 0.96385, -312.07457, 73.19284)",
    fill: "#2f2e41"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 835.97564,
    cy: 653.99965,
    rx: 19.93542,
    ry: 6.25834,
    transform: "translate(-78.2263 1236.02296) rotate(-82.28111)",
    fill: "#2f2e41"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 678.22683,
    cy: 532.78419,
    r: 39.87084,
    fill: "#2f2e41"
  })), _rect104 || (_rect104 = /*#__PURE__*/React.createElement("rect", {
    x: 782.17044,
    y: 680.02345,
    width: 12.11266,
    height: 21.70185,
    transform: "matrix(-0.26644, -0.96385, 0.96385, -0.26644, 178.49137, 1476.14548)",
    fill: "#2f2e41"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 774.9067,
    cy: 691.9383,
    rx: 3.78521,
    ry: 10.09388,
    transform: "translate(-310.19201 72.93744) rotate(-15.45227)",
    fill: "#2f2e41"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 688.6963,
    cy: 509.94354,
    r: 13.62674,
    fill: "#fff"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 693.05399,
    cy: 503.92402,
    r: 4.54225,
    fill: "#3f3d56"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M878.11577,718.72c14.75449-.73842,26.05463-14.53913,25.23958-30.82474s-13.43665-28.88909-28.19114-28.15067-17.06978,12.32082-16.25473,28.60643S863.36129,719.45844,878.11577,718.72Z",
    transform: "translate(-153.84583 -158.53689)",
    fill: "#cfcce0"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M815.77755,674.45145a9.08449,9.08449,0,0,1-1.46575-18.10977c5.00088-.40475,6.36471,3.56543,6.76947,8.5663S820.77843,674.0467,815.77755,674.45145Z",
    transform: "translate(-153.84583 -158.53689)",
    fill: "#fff"
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 821.01058,
    cy: 663.47341,
    rx: 19.93542,
    ry: 6.25834,
    transform: "translate(-100.56927 1229.39481) rotate(-82.28111)",
    fill: "#2f2e41"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 669.69741,
    cy: 480.68977,
    r: 6,
    fill: "#6c63ff"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M788.579,501.2075a7.45358,7.45358,0,0,0-7.43757-8.41723H778.7653a7.42867,7.42867,0,0,0,.87609-3.5,7.522,7.522,0,0,0-7.5-7.5h-25a7.5,7.5,0,0,0,0,15h2.3761a7.42921,7.42921,0,0,0-.8761,3.5,7.52315,7.52315,0,0,0,5.0625,7.08276,7.45306,7.45306,0,0,0,7.4375,8.41724h25A7.49413,7.49413,0,0,0,788.579,501.2075Z",
    transform: "translate(-153.84583 -158.53689)",
    fill: "#6c63ff"
  })), _rect105 || (_rect105 = /*#__PURE__*/React.createElement("rect", {
    x: 450.99208,
    y: 554.51793,
    width: 0.767,
    height: 4.14182,
    transform: "translate(371.92677 -314.68652) rotate(45)",
    fill: "#3f3d56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDonutsLove);
export default __webpack_public_path__ + "static/media/donutsLove.4734f06e3c73fbac3e6a53c4f234938d.svg";
export { ForwardRef as ReactComponent };